<template>
    <div class="">
        <!-- Modal -->
        <div class="modal fade" id="employeeEdit" tabindex="-1" role="dialog" aria-labelledby="employeeEditLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <form id="editTeamForm" @submit.prevent="editTeamDetail">
                        <div class="modal-body p-4">
                            <div class="clearfix popup-head mb-4">
                                <h2 class="mt-2 float-left"> Edit Team Detail  </h2>
                                <button :disabled="form.busy" class="btn btn-primary float-right">Save & Update</button>
                                <a href="#" class="btn btn-primary float-right mr-2" data-dismiss="modal" aria-label="Close">Cancel</a>
                            </div>
                            <div class="form-group">
                                <label for="" class="label block-label"> Team Name </label>
                                <input v-model="form.team_name" type="text" name="team_name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" />
                            </div>
                            <div class="form-group">
                                <label class="label block-label"> Department</label>
                                <select v-model="form.department_id" name="department_id" class="form-control" :class="{ 'is-invalid': form.errors.has('department_id') }" v-if="departments != null">
                                    <option value="" selected>Select Department</option>
                                    <option v-for="department in departments" v-bind:value="department.id" v-bind:key="department.id">
                                        {{ department.name }}
                                    </option>
                                </select>
                                <has-error :form="form" field="department_id"></has-error>
                            </div>
                            <div class="form-group">
                                <label class="label block-label"> Branch </label>
                                <select v-model="form.branch_id" name="branch_id" class="form-control" :class="{ 'is-invalid': form.errors.has('branch_id') }" v-if="branches != null">
                                    <option value="" selected>Select Branch</option>
                                    <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">
                                        {{ branch.name }}
                                    </option>
                                </select>
                                <has-error :form="form" field="branch_id"></has-error>
                            </div>
                            <div class="form-group">
                                <label class="label block-label"> City <em class="required">*</em> </label>
                                <select v-model="form.city_id" name="city_id" class="form-control" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                                    <option value="" selected>Select City</option>
                                    <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                        {{ city.name }}
                                    </option>
                                </select>
                                <has-error :form="form" field="city_id"></has-error>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- Modal End -->

        <!-- Modal -->
        <div class="modal fade iviteTeam" id="iviteTeam" tabindex="-1" role="dialog" aria-labelledby="inviteTeam" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body invite-team">
                        <div class="popup-head mb-4">
                            <h2 class="mb-3"> Invite your team to sign Digital Welcome card </h2>
                            <p> Here is a list of employees who have email addresses in Finja business. Please choose who would should sign welcome card, or select Add All to include everyone. They'll also receive intro email.  </p>
                            <div class="btn-holder">
                                <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
                                <button type="button" @click="addTeamMembers(team_data.id)" class="btn btn-primary ml-2">Save & Continue</button>
                            </div>
                        </div>
                        <div class="invitee-body">
                            <div class="row">
                                <div class="col-5 people-list">
                                    <h3> Employees  </h3>
                                    <input type="text" id="search-people" class="form-control" placeholder="Search" v-model="search_value" />
                                    <div class="people-box" v-for="(user, index) in users" v-bind:key="user.id">
                                        <div v-if="getMatchingResults(search_value, user.name)">
                                            <div class="image-holder">
                                                <img :src="`/avatar/${user.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />

                                            </div>
                                            <div class="text-box">
                                                <h4> {{user.name}} </h4>
                                                <p v-if="user.designation==null"> No designation </p>
                                                <p v-else> {{user.designation.name}}  </p>
                                                <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                            </div>
                                            <button type="button" @click="flipUserObj(user, index)" class="invite-btn"> Select </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-7 invitee-list" v-if="team_members!=0">
                                    <h3> Employee Added </h3>
                                    <div class="people-box" v-for="(user, index) in team_members" v-bind:key="user.id">
                                        <div class="image-holder">
                                            <img :src="`/avatar/${user.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
                                        </div>
                                        <div class="text-box">
                                            <h4> {{user.name}} </h4>
                                            <p v-if="user.designation==null"> No designation </p>
                                            <p v-else> {{user.designation.name}}  </p>
                                            <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                        </div>
                                        <button type="button" class="cross-btn" @click="flipBackUserObj(user, index)">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-7 invitee-list" v-else>
                                    <h3> Employee Added </h3>
                                    <h5 class="empty-heading" > Their is no team member </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal End -->

        <!-- Modal -->
        <div class="modal fade iviteTeamLead" id="iviteTeamLead" tabindex="-1" role="dialog" aria-labelledby="inviteTeam" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body invite-team">
                        <div class="popup-head mb-4">
                            <h2 class="mb-3"> Invite team lead to sign Digital Welcome card </h2>
                            <p> Here is a list of employees who have email addresses in Finja business. Please choose who would should sign welcome card, or select Add All to include everyone. They'll also receive intro email.  </p>
                            <div class="btn-holder">
                                <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
                                <button type="button" @click="addTeamLeads(team_data.id)" class="btn btn-primary ml-2">Save & Continue</button>
                            </div>
                        </div>
                        <div class="invitee-body">
                            <div class="row">
                                <div class="col-5 people-list">
                                    <h3> Employees  </h3>
                                    <input type="text" id="search-people" class="form-control" placeholder="Search" v-model="search_value" />
                                    <div class="people-box" v-for="(user, index) in users" v-bind:key="user.id">
                                        <div v-if="getMatchingResults(search_value, user.name)">
                                            <div class="image-holder">
                                                <img :src="`/avatar/${user.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />

                                            </div>
                                            <div class="text-box">
                                                <h4> {{user.name}} </h4>
                                                <p v-if="user.designation==null"> No designation </p>
                                                <p v-else> {{user.designation.name}}  </p>
                                                <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                            </div>
                                            <button type="button" @click="flipUserObj(user, index)" class="invite-btn"> Select </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-7 invitee-list" v-if="team_members!=0">
                                    <h3> Employee Added </h3>
                                    <div class="people-box" v-for="(user, index) in team_members" v-bind:key="user.id">
                                        <div class="image-holder">
                                            <img :src="`/avatar/${user.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
                                        </div>
                                        <div class="text-box">
                                            <h4> {{user.name}} </h4>
                                            <p v-if="user.designation==null"> No designation </p>
                                            <p v-else> {{user.designation.name}}  </p>
                                            <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                        </div>
                                        <button type="button" class="cross-btn" @click="flipBackUserObj(user, index)">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-7 invitee-list" v-else>
                                    <h3> Employee Added </h3>
                                    <h5 class="empty-heading" > Their is no team lead </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal End -->

        <!-- Modal -->
        <div class="modal fade iviteTeamManager" id="iviteTeamManager" tabindex="-1" role="dialog" aria-labelledby="inviteTeam" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body invite-team">
                        <div class="popup-head mb-4">
                            <h2 class="mb-3"> Invite team lead to sign Digital Welcome card </h2>
                            <p> Here is a list of employees who have email addresses in Finja business. Please choose who would should sign welcome card, or select Add All to include everyone. They'll also receive intro email.  </p>
                            <div class="btn-holder">
                                <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
                                <button type="button" @click="addTeamManager(team_data.id)" class="btn btn-primary ml-2">Save & Continue</button>
                            </div>
                        </div>
                        <div class="invitee-body">
                            <div class="row">
                                <div class="col-5 people-list">
                                    <h3> Employees  </h3>
                                    <input type="text" id="search-people" class="form-control" placeholder="Search" v-model="search_value" />
                                    <div class="people-box" v-for="(user, index) in users" v-bind:key="user.id">
                                        <div v-if="getMatchingResults(search_value, user.name)">
                                            <div class="image-holder">
                                                <img :src="`/avatar/${user.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />

                                            </div>
                                            <div class="text-box">
                                                <h4> {{user.name}} </h4>
                                                <p v-if="user.designation==null"> No designation </p>
                                                <p v-else> {{user.designation.name}}  </p>
                                                <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                            </div>
                                            <button type="button" @click="flipUserObj(user, index)" class="invite-btn"> Select </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-7 invitee-list" v-if="team_members!=0">
                                    <h3> Employee Added </h3>
                                    <div class="people-box" v-for="(user, index) in team_members" v-bind:key="user.id">
                                        <div class="image-holder">
                                            <img :src="`/avatar/${user.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
                                        </div>
                                        <div class="text-box">
                                            <h4> {{user.name}} </h4>
                                            <p v-if="user.designation==null"> No designation </p>
                                            <p v-else> {{user.designation.name}}  </p>
                                            <span class="team-tag" v-for="team in (user.teams)" v-bind:key="team.id"> {{team.team.name}} </span> 
                                        </div>
                                        <button type="button" class="cross-btn" @click="flipBackUserObj(user, index)">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-7 invitee-list" v-else>
                                    <h3> Employee Added </h3>
                                    <h5 class="empty-heading" > Their is no team lead </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal End -->

        <div class="page-top mb-1 mb-3 clearfix">
			<div class="pm-employee-info float-left">
				<div class="image-holder">
                    <img :src="`/avatar/${team_data.manager.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
				</div>
				<div class="info">
					<strong class="title" v-if="team_data.manager!=null"> {{team_data.manager.name}} </strong>
					<p v-if="team_data.manager.designation!=null"> {{team_data.manager.designation.name}} </p>
				</div>
			</div>
			<!-- <a href="#" class="btn btn-primary mt-2 float-right"> Save & Continue </a> -->
            <router-link class="btn btn-primary float-right mr-1" to="/teams">Cancel</router-link>
			<!-- <a href="#" class="btn btn-primary mt-2 float-right mr-1"> Cancel </a> -->
		</div>
		<div class="employee-view-tabs mb-4">
			<ul class="nav nav-tabs nav-tabs-2" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" id="job-detail-tab" data-toggle="tab" href="#job-detail" role="tab" aria-controls="job-detail" aria-selected="true">Details</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" id="personal-tab" data-toggle="tab" href="#personal" role="tab" aria-controls="personal" aria-selected="false">Members</a>
				</li>
			</ul>
		</div>
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="job-detail" role="tabpanel" aria-labelledby="job-detail-tab">
				<div class="pm-employee-view-main">
					<div class="row">
						<div class="col-md-8">
							<label class="label block-label highlight-color mb-3 clearfix"> 
								<span class="highlight-color float-left"> Team Information </span>
								<a href="#" class="float-right"  data-toggle="modal" data-target="#employeeEdit"> <i class="fas fa-pencil-alt"></i> </a>
							</label>
							<div class="pm-employee-detail-box mb-3">
								<div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Team Name: </strong> </div>
									<div class="col-md-8"> <p> {{team_data.name}} </p> </div>
								</div>
                                <div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Department: </strong> </div>
									<div class="col-md-8"> <p v-if="team_data.department!=null"> {{team_data.department.name}} </p> </div>
								</div>
								<div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Team Based In: </strong> </div>
									<div class="col-md-8"> <p v-if="team_data.city!=null"> {{team_data.city.name}} </p> </div>
								</div>
								<!-- <div class="row mb-2">
									<div class="col-md-4"> <strong class="title"> Branch: </strong> </div>
									<div class="col-md-8"> <p v-if="team_data.branch!=null"> {{team_data.branch.name}} </p> </div>
								</div> -->
								
							</div>
						</div>
						<div class="col-md-4 mt-4">
							<!-- <div class="pm-right-sidebar mb-2 mt-2 p-3">
								<p class="mb-2"> Additional Payrolls </p>
								<p><a href="javascript:void(0)" data-toggle="modal" data-target="#iviteTeamManager">Add new team manger</a></p>
                                <p><a href="javascript:void(0)" data-toggle="modal" data-target="#iviteTeamLead">Add new team lead</a></p>
								<p><a href="javascript:void(0)" data-toggle="modal" data-target="#iviteTeam"> Add new members </a></p>
							</div> -->
							<div class="alert align-center alert-danger" role="alert">
								<button type="button" @click="deleteTeam(team_data.id)"> Remove Team </button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="tab-pane fade" id="personal" role="tabpanel" aria-labelledby="personal-tab">
				<div class="pm-employee-view-main">
					<div class="row">
						<div class="col-md-8">
							<label class="label block-label highlight-color mb-3 clearfix"> 
								<span class="highlight-color float-left"> Manager </span>
							</label>
                            <div class="team-manager-box mb-3">
								<div class="team-manager-box-inner">
									<div class="team-manager-col">
										<div class="manager-title">
											<div class="image-holder"> 
                                                <img :src="`/avatar/${team_data.manager.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
											</div>
											<div class="title-designation">
												<span class="title" v-if="team_data.manager!=null"> {{team_data.manager.name}} </span>
												<span class="designation"> {{team_data.manager.employment_status}} </span>
											</div>
										</div>
									</div>
									<div class="team-manager-col"> {{team_data.manager.mobile_no}} </div>
								</div>
							</div>
							<label class="label block-label highlight-color mb-3 clearfix"> 
								<span class="highlight-color float-left"> Team Lead </span>
							</label>
                            <div class="team-manager-box mb-3">
								<div class="team-manager-box-inner" v-for="(team_lead, index) in team_data.team_leads" :key="index">
									<div class="team-manager-col">
										<div class="manager-title">
											<div class="image-holder"> 
												<img src="/images/table-dummy-image.jpg" alt="" />
											</div>
											<div class="title-designation">
												<span class="title"> {{team_lead.member.name}} </span>
												<span class="designation"> {{team_lead.member.employment_status}} </span>
											</div>
										</div>
									</div>
									<div class="team-manager-col"> {{team_lead.member.mobile_no}} </div>
									<div class="team-manager-col">
										<button data-placement="top" type="button" @click="deleteTeamMember(team_lead.id, index)" title="" class="action delete" data-original-title="Delete"> <i class="fas fa-trash"></i> </button>
									</div>
                                    <div class="team-manager-col">
                                        <a href="#" @click="downloadSalarySlip(team_lead.id)" data-toggle="tooltip" data-placement="top" title="Download" class="action"><i class="fas fa-download"></i></a>
                                    </div>
                                    </div>
							</div>

							<label class="label block-label highlight-color mb-3 clearfix"> 
								<span class="highlight-color float-left"> Team Members </span>
							</label>
                            <div class="team-manager-box mb-3">
								<div class="team-manager-box-inner" v-for="(team_member, key) in team_data.team_members" :key="key">
                                    <div v-if="team_member.member != null"> 
                                        <div class="team-manager-col">
                                            <div class="manager-title">
                                                <div class="image-holder"> 
                                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                                </div>
                                                <div class="title-designation">
                                                    <span class="title"> {{team_member.member.name}} </span>
                                                    <span class="designation"> {{team_member.member.employment_status}} </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="team-manager-col"> {{team_member.member.mobile_no}} </div>
                                        <div class="team-manager-col">
                                            <button data-placement="top" type="button" @click="deleteTeamMember(team_member.id, key)" title="" class="action delete" data-original-title="Delete"> <i class="fas fa-trash"></i> </button>
                                        </div>
                                        <div class="team-manager-col">
                                            <a href="#" @click="downloadSalarySlip(team_member.id)" data-toggle="tooltip" data-placement="top" title="Download" class="action -download"><i class="fas fa-download"></i></a>
                                        </div>
                                    </div>
								</div>
							</div>
						</div>
                        <div class="col-md-4 mt-4">
							<div class="pm-right-sidebar mb-2 mt-2 p-3">
								<!-- <p class="mb-2"> Additional Payrolls </p> -->
                                <p><a href="javascript:void(0)" data-toggle="modal" data-target="#iviteTeamManager">Add new team manger</a></p>
                                <p><a href="javascript:void(0)" data-toggle="modal" data-target="#iviteTeamLead">Add new team lead</a></p>
								<p><a href="javascript:void(0)" data-toggle="modal" data-target="#iviteTeam"> Add new members </a></p>
							</div>
							<!-- <div class="alert align-center alert-danger" role="alert">
								<button type="button" @click="deleteTeam(team_data.id)"> Remove Team </button>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form : new Form({
                    'team_name': '',
                    'department_id': '',
                    'branch_id': '',
                    'city_id': '',
                }),
                search_value:'',
                team_data : {
                    manager:{},
                    city:{},
                    branch:{},
                    department:{},
                    team_leads:[],
                    team_members:[],
                },
                users : null,
                team_members: [],
                team_member_ids: [],
                cities: [],
                departments: [],
                branches: [],
                id : this.$route.params.id,
            };
        },
        updated(){
        },
        methods: {
            getMatchingResults(search, name) {
                if(search == ''){
                    return true
                }else{
                    var new_name = name.toUpperCase();
                    if(new_name.indexOf(search.toUpperCase())>=0){
                        return true;
                    }else{
                        return false;
                    }
                }
            },

            editTeamDetail() {
                this.$Progress.start();
                this.form.put('/api/updateTeam/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.team_data.name = this.form.team_name;
                        this.team_data.department_id = this.form.department_id;
                        this.team_data.branch_id = this.form.branch_id;
                        this.team_data.city_id = this.form.city_id;
                        $('#employeeEdit').modal('hide');
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Team details updated successfully'
                        });
                        // this.$router.push('/administrators');
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            getEditTeamData(){
                this.$Progress.start();
                axios.get('/api/editTeam/'+this.id)
                .then(res => {
                    if(res.status == 200){
                        this.team_data = res.data.team;
                        this.users = res.data.users;
                        this.cities = res.data.cities;
                        this.departments = res.data.departments;
                        this.branches = res.data.branches;
                        this.form.team_name = res.data.team.name;
                        this.form.department_id = res.data.team.department_id;
                        this.form.branch_id = res.data.team.branch_id;
                        this.form.city_id = res.data.team.city_id;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                });
            },
            addTeamManager(id){
                this.$Progress.start();
                if(this.team_members.length > 1 ){
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Please select one manager only.'
                    });
                    return false;
                }
                axios.post('/api/addTeamManager/'+id, {
                    team_members: this.team_members,
                    team_member_ids: this.team_member_ids
                })
                .then(res => {
                    if(res.status == 200){
                        $('#iviteTeamManager').modal('hide');
                        this.$Progress.finish();
                        this.getEditTeamData();
                        toast.fire({
                            type: 'success',
                            title: 'Team Manager added successfully'
                        });
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data...'
                        });
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            addTeamLeads(id) {
                this.$Progress.start();
                axios.post('/api/addTeamLeads/'+id, {
                    team_members: this.team_members,
                    team_member_ids: this.team_member_ids
                })
                .then(res => {
                    if(res.status == 200){
                        $('#iviteTeamLead').modal('hide');
                        this.$Progress.finish();
                        this.getEditTeamData();
                        toast.fire({
                            type: 'success',
                            title: 'Team lead added successfully'
                        });
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data...'
                        });
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            addTeamMembers(id) {
                this.$Progress.start();
                axios.post('/api/addTeamMembers/'+id, {
                    team_members: this.team_members,
                    team_member_ids: this.team_member_ids
                })
                .then(res => {
                    if(res.status == 200){
                        $('#iviteTeam').modal('hide');
                        this.$Progress.finish();
                        this.getEditTeamData();
                        toast.fire({
                            type: 'success',
                            title: 'Team member added successfully'
                        });
                        // this.team_data.team_members = [];
                        // this.team_data.team_members.push(res.data.team.team_members);
                        // this.$router.push('/addTeamConfirmation/'+res.data.data.team_id);
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data...'
                        });
                    }

                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            deleteTeamMember(id, index){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.$Progress.start();
                        axios.get('/api/deleteTeamMember/'+id)
                        .then(res => {
                            if(res.status == 200){
                                // this.team_data.team_members.splice(index, 1);
                                this.getEditTeamData();
                                toast.fire({
                                    type: 'success',
                                    title: 'Your team member has been deleted.'
                                });
                                this.$Progress.finish();
                            }else{
                                this.$Progress.fail();
                                swal.fire({
                                    type: 'error',
                                    title: 'Error to delete employee'
                                });
                            }
                        })
                        .catch(err => {
                            console.log(err);
                            this.$Progress.fail();
                            swal.fire({
                                type: 'error',
                                title: 'Error to delete employee'
                            });
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        this.$Progress.fail();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },
            deleteTeam(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.$Progress.start();
                        axios.get('/api/deleteTeam/'+this.$route.params.id)
                        .then(res => {
                            if(res.status == 200){
                                this.teams = res.data.teams;
                                toast.fire({
                                    type: 'success',
                                    title: 'Your team has been deleted.'
                                });
                                this.$router.push('/teams');
                                this.$Progress.finish();
                            }else{
                                Vue.$Progress.fail();
                                swal.fire({
                                    type: 'error',
                                    title: 'Error to delete team'
                                });
                            }
                        })
                        .catch(err => {
                            Vue.$Progress.fail();
                            swal.fire({
                                type: 'error',
                                title: 'Error to delete team'
                            });
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        Vue.$Progress.fail();
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },
            flipUserObj(user, index){
                this.users.splice(index, 1);
                this.team_members.push(user);
                this.team_member_ids.push(user.id);
            },
            flipBackUserObj(user, index){
                this.team_members.splice(index, 1);
                this.team_member_ids.splice(index, 1);
                this.users.push(user);
            },
            downloadSalarySlip(id){
                this.$Progress.start();
                axios.get('/api/downloadLastSalarySlip/'+id, {responseType: 'arraybuffer'})
                    .then((response) => {

                        if(response.status == 200){
                            let blob = new Blob([response.data], { type: 'application/pdf' })
                            let link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = 'Salary Slip.pdf'
                            link.click();
                            this.showToastBox('success','File Downloaded Successfully');
                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Something Went Wrong Please Try Again');
                        }

                    })
            .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','No Data Found');
            });
            }
        },
        mounted() {
            this.getEditTeamData();
        }
    }
</script>
